import styled from "styled-components";
import { AiFillCloseCircle } from "react-icons/ai";
import { useAdmin } from "../../../context/admin";
import Modal from "../../common/Modal";
import { useEffect, useState } from "react";
import AdminService from "../../../services/admin.service";
import { DailyCost } from "../../../types/common.types";
import { format } from "date-fns";
import removeTimezone from "../../../utils/removeTimezone";
import Calendar from "../../common/Calendar";
import { MdEdit } from "react-icons/md";
import { FaTrash } from "react-icons/fa6";
import { useGlobal } from "../../../context/global";


export default function ListDailyCosts() {
    const { setIsLoading } = useGlobal()
    const { setIsListDailyCostsModalOpen, setIsCreateDailyCostModalOpen, setEditDailyCostData } = useAdmin()
    const [date, setDate] = useState<Date>()
    const [list, setList] = useState<DailyCost[]>([])
    useEffect(() => {
        async function fetchData() {
            setIsLoading(true)
            try {
                if (!date) return
                const response = await AdminService.listDailyCosts(date)
                setList(response.data)
            } catch (error) {
                console.log(error)
            } finally {
                setIsLoading(false)
            }
        }
        fetchData()
    }, [date])

    async function handleDeleteDailyCost(id: string) {
        setIsLoading(true)
        try {
            await AdminService.deleteDailyCost(id)
            if (!date) return
            const response = await AdminService.listDailyCosts(date)
            setList(response.data)
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Modal
        >
            <h1>
                List Daily Costs
            </h1>
            <div className="actions">
                <button type="button"
                style={{margin: '10px 0', float: 'initial'}}
                onClick={() => setIsCreateDailyCostModalOpen(true)}
                >
                    Create Daily Cost
                </button>
            </div>
            <div>
            <Calendar
            selectedDay={date}
            selectPastDays
            setSelectedDay={setDate}
            />
            </div>
            <TableWrapper>
                <Table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Amount</th>
                            <th>Incurred at</th>
                            <th style={{width: '40px'}}></th>
                            <th style={{width: '40px'}}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            list.map((cost) => (
                                <tr className="card" key={cost.id}>
                                    <td>{cost.name}</td>
                                    <td>{cost.amount}</td>
                                    <td>Incurred at: {removeTimezone(cost.incurred_at.toString())}</td>
                                    <td>
                                        <button className="select"
                                        type="button"
                                        onClick={() => setEditDailyCostData(cost)}
                                        >
                                            <MdEdit/>
                                        </button>
                                    </td>
                                    <td>
                                        <button className="select"
                                        type="button"
                                        onClick={() => handleDeleteDailyCost(cost.id)}
                                        >
                                            <FaTrash/>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </Table>
            </TableWrapper>
            <div className="close"
            onClick={() => {
                setIsListDailyCostsModalOpen(false)
            }}
            >
                <AiFillCloseCircle/>
            </div>
        </Modal>
    )
}


const TableWrapper = styled.div`
width: 100%;
overflow: auto;
min-height: 80px;
`

const Table = styled.table`
border-collapse: collapse;
position: relative;
table-layout: fixed;
height: 100%;
width: 100%;
min-width: 350px;
thead {
    width: 100%;
    background-color: #FFFFFF;
}
th {
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
}
td {
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    .flag {
        width: 30px;
    }
    button.select {
        width: 20px;
        height: 20px;
        color: #000;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        line-height: 40px;
        background-color: ${props => props.theme.white};
        border: 1px solid ${props => props.theme.black};
        border-radius: 5px;
        cursor: pointer;
        transition: transform .3s ease;
        &:active {
            transform: scale(0.8);
        }
    }
    button.selected {
        background-color: ${props => props.theme.yellowDark};
    }
    button.info {
        border: none;
        background-color: none;
        font-size: 16px;
        cursor: pointer;
    }
}
tr {
    height: 40px;
    width: 100%;
}
`